/**
 * Project related api calls are kept here
 */

import axios, { baseRequestConfig } from './base';

export function getProjectList(userToken, { projectName, onlymine }) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_list',
        values: {
          project_name: projectName,
          onlymine,
        },
      },
    },
  });
}

export function getOrganizerProjectList(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_organizer_myprojects',
      },
    },
  });
}

export function editProject(userToken, project) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_edit',
        values: {
          ...project,
        },
      },
    },
  });
}

export function getProjectEditDetails(userToken, projectId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_edit_get',
        values: {
          project_id: projectId,
        },
      },
    },
  });
}

export function getProjectDetails(userToken, projectId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_get_details',
        values: {
          detail: 'FULL',
          project_id: projectId,
        },
      },
    },
  });
}

export function getProjectTasks(userToken, projectId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_get_tasks',
        values: {
          project_id: projectId,
        },
      },
    },
  });
}

export function reorderProjectMedia(userToken, projectId, projectDataRankRange, projectDataList) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_data_resort',
        values: {
          project_id: projectId,
          project_data_rank_range: projectDataRankRange,
          project_data_list: projectDataList,
        },
      },
    },
  });
}

export function getNewProjectId(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_get_id',
      },
    },
  });
}

export function getProjectEditDefaults(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'project_edit_defaults',
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/projects.js